import { Navigate, Route, Routes } from 'react-router-dom';
import ScrollToTop from '../utils/ScrollToTop';
import { getAccessToken } from '../utils/userStorage';
import Cards from './views/Cards';
import Rewards from './views/Rewards';
import Favorites from './views/Favorites';
import Orders from './views/Orders';
import OrderDetailView from './views/Orders/components/OrderDetailView';
import Profile from './views/Profile';
import { Flex } from '../GlobalComponents/Flex';
import { Container } from '../GlobalComponents/Container';
import { Outer } from '../Layout/Router/Outer';

export const Account: React.FC = () => {
	const authenticated = getAccessToken();

	if (!authenticated) {
		return <Navigate to="/" replace />;
	}

	return (
		<Flex $justifyContent="center">
			<Container width={'1140'}>
				<div className="d-flex mt-3 mb-5">
					<ScrollToTop>
						<AccountRoutes />
					</ScrollToTop>
				</div>
			</Container>
		</Flex>
	);
};

export const AccountRoutes: React.FC = () => {
	return (
		<Routes>
			<Route element={<Outer />}>
				<Route path="profile" element={<Profile />} />
				<Route path="favorites" element={<Favorites />} />
				<Route path="orders" element={<Orders />} />
				<Route path="rewards" element={<Rewards />} />
				<Route path="cards" element={<Cards />} />
				<Route path="orders/:id" element={<OrderDetailView />} />
				<Route path="/" element={<Navigate to="rewards" replace />} />
				<Route path="*" element={<Navigate to="rewards" replace />} />
			</Route>
		</Routes>
	);
};
